import React, { useEffect } from 'react'
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'

const BinderCover = ({ printOutPdfDetails, printRef,onRenderReady }: any) => {
    useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);

    return (
        <div className='row' id='BinderCover' ref={printRef} style={{ pageBreakAfter: "always" }}>
            <div className='col-md-12 px-5'>
                <div className='d-flex justify-content-center align-items-center mt-4'>
                    <ImageWithBasePath
                        src="assets/img/logo.svg"
                        className=""
                        alt="Logo"
                        width={300}
                        height={68}
                    />
                </div>
            </div>
            <div className='px-5 mt-3 text-center'>
                <h3 className='text-center fw-bold text-decoration-underline mt-4'>
                    {printOutPdfDetails?.primaryContactLastName}
                    {printOutPdfDetails?.secondaryContactLastName ? '/' : ''} {printOutPdfDetails?.secondaryContactLastName}
                </h3>

                <p className='mt-3'>
                    <b>
                        PROJECT #  {printOutPdfDetails?.projectNumber}
                    </b>
                </p>
                <div>
                    <p className='mb-0'>
                        {printOutPdfDetails?.propertyAddressLine1} {" "}
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.propertyAddressLine2} {" "}
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.propertyCity} {printOutPdfDetails?.propertyState ? ',' : ''} {printOutPdfDetails?.propertyState}  {printOutPdfDetails?.propertyZipCode}
                    </p>
                </div>
                <div className='mt-5'>
                    <div className='d-flex gap-3 justify-content-center'>
                        <div>
                            <div className='d-flex '>
                                <p className='w-20'>
                                    Home Phone :
                                </p>
                                <p className=''>
                                    {printOutPdfDetails?.homePhone}
                                </p>
                            </div>
                            <div className='d-flex '>

                                <p className='w-20'>
                                    Work Phone :
                                </p>
                                <p className='mb-0'>
                                    {printOutPdfDetails?.workPhone}
                                </p>
                            </div>
                            <div className='d-flex '>

                                <p className='w-20'>
                                    Mobile Phone :
                                </p>
                                <p className='mb-0'>
                                    {printOutPdfDetails?.cellPhone}
                                </p>
                            </div>

                        </div>
                    </div>

                    <h4 className='mt-3'>
                        SELECTION BINDER
                    </h4>

                    <div className='text-center mt-5'>
                        <p className='mb-0'>
                            <b>
                                CORPORATE OFFICES AND DESIGN CENTER {" "}
                            </b>
                            6825 N. Lincoln Ave., Lincolnwood, IL 60712 <b> BRANCH OFFICE</b> Hinsdale, IL
                        </p>
                        <p>
                            <b>AIROOM INC.</b> - 847.967.ROOM - 847.763.1101 (fax) - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BinderCover
